import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://reflex-backend.alfaoir1.workers.dev";

export default function AdminHiring() {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tags, setTags] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = () => {
      fetch(`${API}/applications`, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        }
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.success) setApplicants(data.applicants);
          else setError("Failed to load applicants.");
          setLoading(false);
        })
        .catch(() => {
          setTimeout(() => {
            fetch(`${API}/applications`, {
              headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
              }
            })
              .then((r) => r.json())
              .then((data) => {
                if (data.success) setApplicants(data.applicants);
                else setError("Failed to load applicants.");
                setLoading(false);
              })
              .catch(() => {
                setError("Could not connect to backend.");
                setLoading(false);
              });
          }, 1000);
        });
    };
    loadData();
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("applicant_tags");
    if (saved) setTags(JSON.parse(saved));
  }, []);

  const setTag = (id, tag, e) => {
    e.stopPropagation();
    setTags((prev) => {
      const current = prev[id];
      const updated = { ...prev, [id]: current === tag ? null : tag };
      localStorage.setItem("applicant_tags", JSON.stringify(updated));
      return updated;
    });
  };

  const deleteApplicant = (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Are you sure you want to delete this applicant?")) return;

    fetch(`${API}/applications/${id}`, { method: "DELETE" })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setApplicants((prev) => prev.filter((a) => a._id !== id));
          setTags((prev) => {
            const updated = { ...prev };
            delete updated[id];
            localStorage.setItem("applicant_tags", JSON.stringify(updated));
            return updated;
          });
        } else {
          alert("Failed to delete applicant.");
        }
      })
      .catch(() => alert("Could not connect to backend."));
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <button onClick={() => navigate("/admin")} style={s.backBtn}>
          ← Back to Admin
        </button>
        <p style={s.label}>Admin Panel</p>
        <h1 style={s.title}>Job Applications</h1>
        <p style={s.sub}>Click any applicant to view their full profile.</p>
      </div>

      <div style={s.content}>
        {loading && <p style={s.msg}>Loading...</p>}
        {error && <p style={s.err}>{error}</p>}

        {!loading && !error && (
          <>
            <p style={s.count}>
              {applicants.length} application
              {applicants.length !== 1 ? "s" : ""} received
            </p>

            {applicants.length === 0 ? (
              <p style={s.msg}>No applications yet.</p>
            ) : (
              <div style={s.tableWrap}>
                <table style={s.table}>
                  <thead>
                    <tr>
                      <th style={s.th}>#</th>
                      <th style={s.th}>Full Name</th>
                      <th style={s.th}>Email</th>
                      <th style={s.th}>Phone</th>
                      <th style={s.th}>Submitted</th>
                      <th style={s.th}>Status</th>
                      <th style={s.th}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {applicants.map((a, i) => (
                      <tr
                        key={a._id}
                        style={s.row}
                        onClick={() => navigate(`/admin/hiring/${a._id}`)}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#1a0d2e")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={s.td}>{i + 1}</td>

                        <td style={{ ...s.td, color: "#a855f7", fontWeight: 600 }}>
                          {a.fullName || "—"}
                        </td>

                        <td style={s.td}>{a.email || "—"}</td>

                        <td style={s.td}>{a.phone || "—"}</td>

                        <td style={s.td}>
                          {a.submittedAt
                            ? new Date(a.submittedAt).toLocaleDateString()
                            : "—"}
                        </td>

                        <td
                          style={{ ...s.td, whiteSpace: "nowrap" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            style={{
                              ...s.iconBtn,
                              color: tags[a._id] === "good" ? "#22c55e" : "#374151",
                              background:
                                tags[a._id] === "good"
                                  ? "rgba(34,197,94,0.1)"
                                  : "transparent",
                            }}
                            onClick={(e) => setTag(a._id, "good", e)}
                          >
                            ✓
                          </button>

                          <button
                            style={{
                              ...s.iconBtn,
                              color: tags[a._id] === "bad" ? "#ef4444" : "#374151",
                              background:
                                tags[a._id] === "bad"
                                  ? "rgba(239,68,68,0.1)"
                                  : "transparent",
                            }}
                            onClick={(e) => setTag(a._id, "bad", e)}
                          >
                            ✕
                          </button>

                          <button
                            style={{
                              ...s.iconBtn,
                              color: tags[a._id] === "star" ? "#f59e0b" : "#374151",
                              background:
                                tags[a._id] === "star"
                                  ? "rgba(245,158,11,0.1)"
                                  : "transparent",
                            }}
                            onClick={(e) => setTag(a._id, "star", e)}
                          >
                            ★
                          </button>
                        </td>

                        <td style={s.td} onClick={(e) => e.stopPropagation()}>
                          <button
                            style={s.deleteBtn}
                            onClick={(e) => deleteApplicant(a._id, e)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page: {
    background: "#0a0a0f",
    minHeight: "100vh",
    color: "#fff",
    fontFamily: "Inter, sans-serif",
  },
  header: {
    background: "linear-gradient(135deg, #0f0a1e, #1a0d2e)",
    padding: "40px 40px 40px",
    borderBottom: "1px solid #1f1f2e",
  },
  backBtn: {
    background: "rgba(255,255,255,0.05)",
    border: "1px solid #2a2a3e",
    color: "#9ca3af",
    borderRadius: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    fontSize: "13px",
    marginBottom: "24px",
    fontFamily: "Inter, sans-serif",
    display: "block",
  },
  label: {
    fontSize: "12px",
    color: "#a855f7",
    textTransform: "uppercase",
    letterSpacing: "3px",
    margin: "0 0 10px",
  },
  title: {
    fontSize: "32px",
    fontWeight: 800,
    margin: "0 0 8px",
  },
  sub: {
    fontSize: "15px",
    color: "#6b7280",
    margin: 0,
  },
  content: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "40px 20px",
  },
  count: {
    fontSize: "13px",
    color: "#6b7280",
    marginBottom: "16px",
  },
  tableWrap: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: "12px 16px",
    fontSize: "11px",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "1px",
    borderBottom: "1px solid #1f1f2e",
  },
  row: {
    borderBottom: "1px solid #1f1f2e",
    cursor: "pointer",
  },
  td: {
    padding: "14px 16px",
    fontSize: "14px",
    color: "#d1d5db",
  },
  msg: {
    color: "#6b7280",
    textAlign: "center",
    padding: "60px 0",
  },
  err: {
    color: "#ef4444",
    background: "rgba(239,68,68,0.1)",
    border: "1px solid rgba(239,68,68,0.2)",
    borderRadius: "8px",
    padding: "14px 18px",
  },
  iconBtn: {
    border: "none",
    borderRadius: "6px",
    padding: "5px 8px",
    cursor: "pointer",
    fontSize: "15px",
    marginRight: "4px",
  },
  deleteBtn: {
    background: "rgba(239,68,68,0.08)",
    border: "1px solid rgba(239,68,68,0.2)",
    color: "#ef4444",
    borderRadius: "6px",
    padding: "5px 12px",
    cursor: "pointer",
    fontSize: "12px",
  },
};